import { CpCommerceConstants } from '../../sdk';
import * as fromDatatype from '../datatype-library';

export interface bl_cms_notification_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    cms_topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cms_post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    scheduled_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    last_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    publish_status: CpCommerceConstants.NOTIFICATION_PUBLISH_STATUS;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    deeplink_url: fromDatatype.VarcharDatatypeInterface;
}

export class bl_cms_notification_hdr_RowClass implements bl_cms_notification_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    cms_topic_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cms_post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    scheduled_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    last_publish_date: fromDatatype.TimestampTzDatatypeInterface;
    publish_status: CpCommerceConstants.NOTIFICATION_PUBLISH_STATUS;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    deeplink_url: fromDatatype.VarcharDatatypeInterface;
}
